<template>
  <c-link
    v-bind="$attrs"
    v-on="getListeners()"
    @click.native="$emit('click', $event)"
  >
    <slot />
  </c-link>
</template>

<script setup>
import CLink from '@convenia/components/CLink'

const props = defineProps({
  componentListeners: {
    type: Object,
    required: true,
  }
})

const getListeners = () => {
  const {
    click,
    ...listeners
  } = props.componentListeners

  return listeners
}

defineEmits([ 'click' ])
</script>
